import { AccountParticipationLevel } from '@nemuru-eng/js-api-client';
import React from 'react';

import { Text } from '../../../shared/components/Text';

export const AccountHolderParticipationLevelOptions = Object.values(AccountParticipationLevel).map((value) => ({
  value,
  display: <Text tId={`${value}_OPTION`} />,
}));
